import React, { forwardRef } from 'react';
import cx from 'classnames';
import { useDesignTokens, renderInlineCssVars } from '@sas/nova-commons/theme';
import cn from './StackLink.css.json';
import './StackLink.css';
export const StackLink = forwardRef((props, ref) => {
    const dt = useDesignTokens();
    return (React.createElement("div", { ref: ref, className: cn.stackLink, style: renderInlineCssVars(StackLinkTokens(props.selected, dt), 'stack-link'), onClick: () => props.onClick && props.onClick(), "data-testid": props.testId, tabIndex: props.tabIndex, "aria-selected": props.selected, role: "tab" },
        React.createElement("span", { className: cx(cn.stackLinkText, !props.wrapText && cn.stackLinkNoWrap) }, props.label)));
});
function StackLinkTokens(selected, dt) {
    return {
        fg: selected ? dt.c.primary : dt.stateStandardContentNova.normal.fg,
        'text-decoration': selected ? 'none' : 'underline',
        cursor: selected ? 'default' : 'pointer',
    };
}
